import styled from 'styled-components';

import { Colors } from 'environment';

export const SeparatorBorder = styled.div`
	border: 0.1rem solid ${Colors.text.disabled};
`;
